import RecordingBlock from "./RecordingBlock.vue"

export default function install(Vue) {
  Vue.component(RecordingBlock.name, RecordingBlock)
}
